module.exports = __webpack_public_path__ + "img/pad_warning_blue.494ab00a.svg";